// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import {userSetItem, userAddItem,userGetItem} from '../../actions/userActions';
import {areaGetItem} from '../../actions/areaActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/user/AddEditForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants, userConstants} from "../../constants";
import {list as areaList} from '../../containers/area/AreaListPage';
import {reset} from "redux-form";


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.user.getItem,
        userValue: state.app.currentUser,
        areaList : state.area.areaList,
        // initialValues:{
        //     email:'ooo@ff.com'
        // }
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getItem: (id) => {
        dispatch(getItem(id));
    },
    getAreaList : () => {
        return(dispatch(areaList()));
    },

    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        if(value.mode == 'edit')
            dispatch(edit(value));
        else
            dispatch(add(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const add = (values,mode) => {
    let branchCity = values.branch_city;
    let branchCities = [];

    if(values.branchCity != null) {
        for(let i  = 0;i< branchCity.length ; i++)
        {
            branchCities.push({
                i: branchCity[i]
            });
        }
    }

    let avatar = ''
    if(values.avatar)
        avatar = values.avatar

    return (dispatch, getState) => {
        var formData = {
            'name'     : values.name,
            'family'   : values.family,
            'username' : values.username,
            'passwd'   : values.passwd,
            'mobile'   : values.mobile,
            'phone_number' : values.phone_number,
            'branch_operator_state'  : values.branch_state,
            'branch_operator_cities' : values.branch_city,
            'role'     : values.role,
            'avatar'   : avatar,
            'is_active': true
        };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.post('user/new', formData).then(list => {
            dispatch(userAddItem(list.data.lists));
            if(list.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
                dispatch(reset('addUser'));
                setTimeout(() => dispatch({type: commonConstants.PAGE_REDIERCT, redirectTo: '/user/list'}), 100)
            }else if(list.data.statusCode === 400 && list.data.system_error_code === 303) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'نام کاربری یا شماره همراه نامعتبر یا تکراری میباشد.نام کاربری میبایست فقط شامل حروف انگلیسی و اعداد باشد'
                })
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ایجاد'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const edit = (values) => {
    let _ = require('lodash');

    let id = values._id;
    if (values.branch_operator_cities) {
        let cities = values.branch_operator_cities
        var branchCity = [];
        for (let i = 0; i < cities.length; i++) {
            if(cities[i] && cities[i]['_id'])
                branchCity.push(cities[i]['_id']);
        }
    }

    return (dispatch, getState) => {

        let states = getState()

        var chooseAddress
        let address = null;
        let addressId;
        let tag = '';
        let geo = null;
        let stateId = 0;
        let cityId = 0;

        if(values.address===1){
            if(values.tag){
                tag = values.tag;
            }
            address = values.new_address;
            addressId = null;
            stateId = values.stateId;
            cityId = values.cityId;
        } else {
            if(values.address){
                chooseAddress = _.find(states.user.getItem.addresses, function(obj) {
                    return obj._id === values.address;
                });
            }
            if(values.new_address!=undefined){
                address=values.new_address
            }else{
                if(chooseAddress!=undefined){
                    address=chooseAddress.text
                }
            }
            if(values.geo!=undefined){
                geo=values.geo
            }else{
                if(chooseAddress!=undefined){
                    if(chooseAddress.geo!=undefined){
                        geo=chooseAddress.geo
                    } else {
                        geo=""
                    }
                }
            }
            if(values.tag!=undefined){
                tag=values.tag
            }else{
                if(chooseAddress!=undefined){
                    tag=chooseAddress.tag
                }
            }
            if(values.stateId!=undefined){
                stateId=values.stateId
            }else{
                if(chooseAddress!=undefined){
                    stateId=chooseAddress.stateId
                }
            }
            if(values.cityId!=undefined){
                cityId=values.cityId
            }else{
                if(chooseAddress!=undefined){
                    cityId=chooseAddress.cityId
                }
            }
            if(chooseAddress!=undefined){
                if(chooseAddress._id!=undefined){
                    addressId=chooseAddress._id
                }else{
                    addressId=null
                }
            }
        }

        var formData;

        if(states.user.getItem.role === 'TECHNICIAN')
            formData = {
                mobile:values.mobile,
                'name'     : values.name,
                'family'   : values.family,
                'phone_number' : values.phone_number,
                'passwd'   : values.passwd,
                'is_active': values.is_active === 1 ? true : false,
                'branch_operator_state'  : values.branch_state ? values.branch_state : values.branch_operator_state._id,
                'branch_operator_cities' : values.branch_city ? values.branch_city : branchCity,
                'avatar'   : values.avatar,
                'address'   : {
                    addressId      : addressId,
                    geo     : geo,
                    stateId : stateId,
                    cityId  : cityId,
                    text    : address,
                    tag     : tag,
                },
            };
        else
            formData = {
                mobile:values.mobile,
                'name'     : values.name,
                'family'   : values.family,
                'phone_number' : values.phone_number,
                'passwd'   : values.passwd,
                'is_active': values.is_active === 1 ? true : false,
                'avatar'   : values.avatar,
                'address'   : {
                    addressId      : addressId,
                    geo     : geo,
                    stateId : stateId,
                    cityId  : cityId,
                    text    : address,
                    tag     : tag,
                },
            };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('user/edit/'+id, formData).then(editRes => {
            dispatch(userSetItem(editRes.data));
            if(editRes.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد',
                })
                setTimeout(() => dispatch({type: commonConstants.PAGE_REDIERCT, redirectTo: '/user/list'}), 500)
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ویرایش'
                })
            }
        }).catch(error => {
            console.log(error)
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

export const getItem = (id) => {
    return (dispatch, getState) => {
        API_FETCH.get('user/'+id).then(userInfo => {
            dispatch(userGetItem(userInfo.data));
        }).catch(error => {
            console.log(error);
        });
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
